import { Injectable, Injector } from '@angular/core';
import { BaseService } from '@common-modules/shared/base.service';
import { UserDto } from '@common-modules/shared/model/roles/user.dto';
import { Observable, map } from 'rxjs';

@Injectable()
export class UsersService extends BaseService {
  private _entityUrl: string;

  constructor(injector: Injector) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/roles/users`;
  }

  getUserByCode(userCode: string): Observable<UserDto> {
    return this.httpCacheClient.get<UserDto>(`${this._entityUrl}/${userCode}`).pipe(
      map((user) => {
        user.groupIds = user.groups;
        delete user.groups;
        return user;
      })
    );
  }
}
